import { useGuestEventHotelRoomBlocksQuery, useGuestPageContainerBySlugQuery } from '@graphql/generated';

export const useCustomData = (eventId: string, eventHandle: string, pageSlug: string) => {
  const { data: hotelRoomBlocksData, loading: hotelRoomBlocksLoading } = useGuestEventHotelRoomBlocksQuery({
    variables: {
      eventId
    },
    fetchPolicy: 'cache-and-network',
    batchMode: 'fast'
  });
  const destination = hotelRoomBlocksData?.event?.hotelRoomBlocks?.destination || {};
  const reservedRoomBlocks = hotelRoomBlocksData?.event?.hotelRoomBlocks?.reservedRoomBlocks;
  const eventPhoto = hotelRoomBlocksData?.event?.photo?.url ?? '';

  const { data: pageContainerData, loading: pageContainerLoading } = useGuestPageContainerBySlugQuery({
    variables: {
      payload: {
        eventName: eventHandle,
        pageSlug: pageSlug
      }
    },
    fetchPolicy: 'cache-and-network',
    batchMode: 'fast'
  });

  const travelMapComponent = pageContainerData?.pageContainerBySlug?.components?.find(component => component.__typename === 'TravelMapComponent');
  const blockOrderingInitial = travelMapComponent && travelMapComponent.__typename === 'TravelMapComponent' ? travelMapComponent?.blockOrdering : [];
  const blockOrdering =
    blockOrderingInitial && blockOrderingInitial?.length === reservedRoomBlocks?.length ? blockOrderingInitial : reservedRoomBlocks?.map(roomBlock => roomBlock.id);

  return {
    loading: hotelRoomBlocksLoading || pageContainerLoading,
    destination,
    eventPhoto,
    reservedRoomBlocks,
    blockOrdering
  };
};
